import React from 'react';
import _get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { getValidityHintIcon } from '@lib/utils/validityHint';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function ValidityHintOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const value = _get(option, 'value', '') as string;

  // Fragment, not a wrapping div: SelectPanelOption already renders the
  // `optionButton`/`optionSelected`/`optionWithCheckbox` classes on the
  // surrounding <button> (see SelectPanelOption.tsx), so this only supplies
  // the button's inner content, matching SectorOption/AssetOption/DefaultOption.
  return (
    <>
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.validityHintOptionContent}>
        {getValidityHintIcon(value)}
        <span className={styles.optionLabel}>{getOptionLabel(option, t)}</span>
      </span>
    </>
  );
}
